import React from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { labelsCandidateDocumentForTable } from 'common/document/ui/documents';
import { OnboardingDocs } from 'components/OnboardingDocs';

export const documentTypeRender = (
  props: GridRenderCellParams<any, any, any>
) => {
  const { row } = props;
  return row.documentsRequestedCount === 1 ? (
    <>
      {labelsCandidateDocumentForTable.get(row.documentsNeeded[0]) ||
        row.documentsNeeded}
    </>
  ) : (
    <OnboardingDocs
      submitted={row.submitedDocumentsCount}
      needed={row.documentsRequestedCount}
    />
  );
};
